export default __webpack_public_path__ + "static/media/keymanInsurance_main.c07d93c2.jpg";